import { MutationOptions, useMutation } from 'react-query';

import { convertEmptyStringToNull } from '@app/features/addressBook/libs';
import {
  updateContactsById,
  UpdateContactsByIdParams,
  UpdateContactsByIdResponse,
} from '@app/store/transport-layer/document/address-book/contacts';

const useUpdateContactsById = (
  options?: MutationOptions<UpdateContactsByIdResponse, Error, UpdateContactsByIdParams>
) => {
  return useMutation<UpdateContactsByIdResponse, Error, UpdateContactsByIdParams>(
    ({
      bizNumber,
      companyName,
      defaultForwardingMethod,
      departmentPosition,
      description,
      email,
      id,
      name,
      phoneNumber,
    }) =>
      updateContactsById({
        bizNumber: convertEmptyStringToNull(bizNumber),
        companyName: convertEmptyStringToNull(companyName),
        defaultForwardingMethod,
        departmentPosition: convertEmptyStringToNull(departmentPosition),
        description: convertEmptyStringToNull(description),
        email: convertEmptyStringToNull(email),
        id,
        name,
        phoneNumber: convertEmptyStringToNull(phoneNumber),
      }),
    { mutationKey: 'addressBookContactUpdateById', ...options }
  );
};

export default useUpdateContactsById;
